// @flow
import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { getPlaceDetails } from '../../../helpers/maps';

type State = {
  placeId: string,
  countryCode: string,
  lat: string,
  lng: string,
  name: string
};

const defaultState: State = {
  placeId: '',
  countryCode: '',
  lat: '',
  lng: '',
  name: ''
};

type Props = {
  placeId?: string,
  initialCoords?: any,
  callback?: (...args: Array<any>) => any,
  sessionToken: string
};

export default class GoogleDetails extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const state = defaultState;

    if (!isEmpty(props.initialCoords)) {
      state.lat = props.initialCoords.lat;
      state.lng = props.initialCoords.lng;
    }

    this.state = state;
  }

  componentDidMount() {
    this.setGoogleData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.placeId !== this.props.placeId) {
      this.setState(defaultState);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.placeId !== this.props.placeId) {
      this.setGoogleData();
    }
  }

  setGoogleData() {
    if (isEmpty(this.props.placeId)) {
      return;
    }

    getPlaceDetails(this.props.placeId, this.props.sessionToken).then(
      details => {
        this.setState(
          {
            placeId: this.props.placeId,
            countryCode: details.address_components.pop().short_name,
            lat: details.geometry.location.lat(),
            lng: details.geometry.location.lng(),
            name: details.name
          },
          () => {
            this.props.callback(this.state);
          }
        );
      }
    );
  }

  render() {
    return (
      <div>
        <input type="hidden" name="source" value="autocomplete" />
        <input type="hidden" name="ac_country" value={this.state.countryCode} />
        <input type="hidden" name="place_id" value={this.state.placeId} />
        <input type="hidden" name="location_name" value={this.state.name} />
        <input
          type="hidden"
          name="coords"
          value={`${this.state.lat},${this.state.lng}`}
        />
      </div>
    );
  }
}

GoogleDetails.defaultProps = {
  placeId: '',
  initialCoords: {},
  callback: () => {}
};
